import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { OwnerProfileResource } from "@exonn/js-sdk";

export const module: ModuleOptions<OwnerProfileResource> = {
  resource: ResourceEnum.OwnerProfile,
  bigIcon: <span className={"icon-20-custmr_prfl"} />,
  smallIcon: <span className={"icon-15-custmr_prfl"} />,
};
